import { NETWORK_CONFIG, LOGO_URL } from "@/constants/network";
import { EXTERNAL_CHAINS } from "@/constants/externalChains";

const PROJECT_ID = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID;
export const isWalletConnectEnabled = Boolean(PROJECT_ID);

let providerPromise = null;

const createProvider = async () => {
  const { EthereumProvider } = await import("@walletconnect/ethereum-provider");
  return EthereumProvider.init({
    projectId: PROJECT_ID,
    showQrModal: false,
    optionalChains: [NETWORK_CONFIG.chainId, ...EXTERNAL_CHAINS.map((c) => c.id)],
    rpcMap: { [NETWORK_CONFIG.chainId]: NETWORK_CONFIG.rpcUrls[0], ...Object.fromEntries(EXTERNAL_CHAINS.map((c) => [c.id, c.rpc])) },
    optionalMethods: ["eth_sendTransaction", "personal_sign", "eth_signTypedData_v4", "wallet_addEthereumChain", "wallet_switchEthereumChain", "wallet_watchAsset"],
    metadata: {
      name: "FMI Smart Chain Hub",
      description: "Explorer, faucet, exchange and DEX for FMI Smart Chain",
      url: window.location.origin,
      icons: [`${window.location.origin}${LOGO_URL}`],
    },
  });
};

const getProvider = () => {
  if (!providerPromise) providerPromise = createProvider().catch((e) => { providerPromise = null; throw e; });
  return providerPromise;
};

/** Starts a WalletConnect session; onUri receives the pairing link for the QR / copy button. */
export async function connectWalletConnect(onUri) {
  const provider = await getProvider();
  if (provider.session) await provider.disconnect().catch(() => {});
  provider.on("display_uri", onUri);
  try {
    await provider.connect();
    return provider;
  } finally {
    provider.removeListener("display_uri", onUri);
  }
}

export async function disconnectWalletConnect(provider) {
  if (provider?.isWalletConnect) await provider.disconnect().catch(() => {});
}
